export default __webpack_public_path__ + "static/media/4.614a3450.jpg";